module.exports = __webpack_public_path__ + "static/media/pie-icon.5acaf61c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pie-icon.svg
// module id = ./src/assets/icons/pie-icon.svg
// module chunks = 0